/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Office } from '../../models/office';

export interface GetAllOffices$Json$Params {
}

export function getAllOffices$Json(http: HttpClient, rootUrl: string, params?: GetAllOffices$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Office>>> {
  const rb = new RequestBuilder(rootUrl, getAllOffices$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Office>>;
    })
  );
}

getAllOffices$Json.PATH = '/api/Office';
